import { motion } from "framer-motion";
import logo from "../assets/logo/telefect-logo-icon.png";

const orbitTransition = {
  repeat: Infinity,
  duration: 7,
  ease: "linear",
};

const LoaderNext = () => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden bg-white text-main-color transition-colors duration-300 dark:bg-[#080f12] dark:text-white"
    >
      {/* Premium Background */}
      <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_50%_45%,rgba(2,101,118,0.16),transparent_32%),radial-gradient(circle_at_80%_20%,rgba(168,52,23,0.12),transparent_26%),linear-gradient(180deg,#ffffff_0%,#f8fbfc_100%)] dark:bg-[radial-gradient(circle_at_50%_45%,rgba(0,218,255,0.12),transparent_32%),radial-gradient(circle_at_80%_20%,rgba(203,51,13,0.18),transparent_26%),linear-gradient(180deg,#080f12_0%,#101719_100%)]" />

      <div className="absolute inset-0 -z-20 bg-[linear-gradient(to_right,rgba(2,101,118,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(2,101,118,0.05)_1px,transparent_1px)] bg-[size:44px_44px] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.035)_1px,transparent_1px)]" />

      {/* Glow */}
      <motion.div
        className="absolute h-72 w-72 rounded-full bg-three-color/20 blur-3xl dark:bg-cyan-300/10"
        animate={{ scale: [1, 1.18, 1], opacity: [0.45, 0.8, 0.45] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Loader */}
      <div className="relative flex h-56 w-56 items-center justify-center">
        {/* Outer Ring */}
        <motion.div
          className="absolute inset-0 rounded-full border border-main-color/10 dark:border-white/10"
          animate={{ rotate: 360 }}
          transition={orbitTransition}
        />

        <motion.div
          className="absolute inset-5 rounded-full border border-dashed border-three-color/35 dark:border-cyan-300/30"
          animate={{ rotate: -360 }}
          transition={{ ...orbitTransition, duration: 10 }}
        />

        {/* Center Logo Card */}
        <motion.div
          className="relative z-10 flex h-28 w-28 items-center justify-center rounded-[2rem] border border-gray-100 bg-white/85 shadow-2xl shadow-main-color/10 backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.06] dark:shadow-black/30"
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <img
            src={logo}
            alt="Telefect logo"
            className="h-20 w-20 object-contain drop-shadow-lg"
          />
        </motion.div>

        {/* Orbiting Dots */}
        <motion.span
          className="absolute left-1/2 top-0 h-4 w-4 rounded-full bg-three-color shadow-[0_0_20px_rgba(2,101,118,0.7)] dark:bg-cyan-300"
          animate={{ rotate: 360 }}
          transition={orbitTransition}
          style={{ originX: -6, originY: 7 }}
        />

        <motion.span
          className="absolute bottom-2 left-1/2 h-3.5 w-3.5 rounded-full bg-sec-color shadow-[0_0_20px_rgba(168,52,23,0.7)] dark:bg-orange-300"
          animate={{ rotate: -360 }}
          transition={{ ...orbitTransition, duration: 8.5 }}
          style={{ originX: -7, originY: -7 }}
        />

        <motion.span
          className="absolute right-2 top-1/2 h-3 w-3 rounded-full bg-main-color shadow-[0_0_20px_rgba(3,62,72,0.7)] dark:bg-white"
          animate={{ rotate: 360 }}
          transition={{ ...orbitTransition, duration: 11 }}
          style={{ originX: -8, originY: 0 }}
        />
      </div>

      {/* Text */}
      <motion.div
        className="mt-6 text-center"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.p
          className="text-sm font-black uppercase tracking-[0.35em] text-main-color dark:text-white"
          animate={{ opacity: [0.45, 1, 0.45] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
        >
          Loading
        </motion.p>

        <p className="mt-2 text-xs font-medium text-gray-500 dark:text-gray-400">
          Preparing your experience...
        </p>
      </motion.div>
    </div>
  );
};

export default LoaderNext;